import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const DocumentContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 1rem;
  padding-left: 4rem;
`;

export const IconContaniner = styled.div`
  position: absolute;
  background: ${colors.RED};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.2rem;
  z-index: 100;
  right: -1rem;
  top: -1rem;
  cursor: pointer;
`;

export default {
  DocumentContainer,
};
